import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const HeatingsTable = () => {
  const {
    state: { heatings, eafProcessData },
  } = useHeatReportContext();

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div
          style={{ height: "20rem" }}
          key={`${heatings.length}-${eafProcessData.ProcessId}`}
        >
          <AgGridReact
            rowData={heatings}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            getRowId={(params) => params.data.HeatingId}
            {...defaultGridOptions}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
